<form class="index" (ngSubmit)="handleLogin()">
  <div class="form-group">
    <input
      type="text"
      className="form-control"
      name="username"
      [(ngModel)]="username"
      placeholder="Email"
    />
  </div>
  <div class="form-group">
    <input
      type="password"
      className="form-control"
      name="password"
      [(ngModel)]="password"
      placeholder="Password"
    />
  </div>
  <input
    type="submit"
    value="Submit"
    class="btn btn-dark btn-primary btn-lg btn-block"
  />
</form>
